import { SortBy } from 'consts';

export const getSortLabel = (sortBy: string): SortBy | string => {
  if (sortBy.trim() === 'Inicio Serv.') {
    return SortBy.FECHA_INI_SERVICIO;
  } else if (sortBy.trim() === 'Fin Serv.') {
    return SortBy.FECHA_FIN_SERVICIO;
  }
  return sortBy;
};
